module.exports = "precision highp float;\r\n\r\nvarying vec3 v_color;\r\n\r\nvoid main() {\r\n  gl_FragColor = vec4(v_color, 1.0);\r\n}\r\n"